// extracted by mini-css-extract-plugin
export default {"lds-ring":"style_lds-ring__0+eDg"};